module.exports = __webpack_public_path__ + "static/media/invoice_coupon_help_v2.7e402d77.png";